import { Injectable } from '@angular/core';
import { Route, Router, Routes, UrlSegment } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ClientFormsService } from '../client-forms.service';
import { MP20242025M2PFormComponent } from './mp2024-2025-m2p-form.component';
import { MP2024FormComponent } from './mp2024-form.component';
import { MP2025P2MFormComponent } from './mp2025-p2m-form.component';

@Injectable()
export class MP2024RoutesLoaderGuard  {
  private routesAdded = false;

  constructor(private router: Router, private clientFormsService: ClientFormsService) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    if (this.routesAdded) return of(true);

    return this.clientFormsService.getFormRoutesAndComponents().pipe(
        map(apiRoutes => {
            this.addDynamicRoutes(apiRoutes);
            return true;
        }),
        catchError((err: any) => {
            return of(true);
        })
    );
  }
  
  private addDynamicRoutes(apiRoutes: any[]) {
    const dynamicRoutes: Routes = apiRoutes.map(r => ({
        path: r.path,
        component: this.mapComponent(r.component),
        data: r.routeData
      }));

      const currentConfig = this.router.config;
      const formsRoute = currentConfig.find(r => r.path === 'forms');
      const mp2024Route = formsRoute?.children?.find(c => c.path?.includes('mp2024'));

      if (mp2024Route) {
        const baseChildren: Routes = [
          { path: 'mp2025-2025-01-p2m', component: MP2025P2MFormComponent },
          ...dynamicRoutes,
          { path: ':instance', component: MP2024FormComponent }
        ];

        // mp2024Route.children = baseChildren;
        // mp2024Route.loadChildren = undefined;
        
        if (!(mp2024Route as any)._loadedRoutes) {
            (mp2024Route as any)._loadedRoutes = [];
        }
          
        (mp2024Route as any)._loadedRoutes.push({
            path: '',
            children: baseChildren
        });
        this.router.resetConfig(currentConfig);
        this.routesAdded = true;
      }
  }

  private mapComponent(name: string): any {
    switch (name) {
      case 'MP20242025M2PFormComponent':
        return MP20242025M2PFormComponent;
      default:
        return MP2024FormComponent;
    }
  }
}